// components/FadeWrapper.jsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const FadeWrapper = ({ children }) => {
  const location = useLocation();
  const [fadeClass, setFadeClass] = useState("fade-in");

  useEffect(() => {
    setFadeClass(""); // Reset the class
    const timeout = setTimeout(() => setFadeClass("fade-in"), 10);
    return () => clearTimeout(timeout);
  }, [location]);

  return <div className={fadeClass}>{children}</div>;
};

export default FadeWrapper;
